var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.countClass,attrs:{"id":"category"}},[_c('product-list',{attrs:{"products":this.products,"productNameTag":this.productNameTag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }